export default __webpack_public_path__ + "4607d81cf7b77fd240bbe9d0ec2bc93f.svg";